<template>
  <div>
    <div v-if="loading">
      `
      <div class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>
    <div v-else class="app-container">
      <div class="banner m-prof-banner">
        <img v-if="profileData[`${entityType}_info`].background_image" :src="profileData[`${entityType}_info`].background_image" alt="bg-image" />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
      </div>
      <div class="profile-subnav">
        <div class="dovemed-wrapper w-100">
          <!-- commented left content -->
          <!-- RIGHT CONTENT -->

          <div class="nav-sec p-4">
            <div v-if="entityType === 'hospital'" class="mt-1 profile-tabs">
              <!-- Psoriasis/profile/view/hcp/251/updates -->
              <div
                id="updates"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                    ? { color: getPrimaryColor(), background: getAlphaPrimaryColor() }
                    : { color: '#0F1734' }
                "
                @click="
                  () => {
                    selectedTab = 'Reviews & More'
                    $router.push({ name: 'HospViewUpdate' })
                  }
                "
              >
                Updates
              </div>
              <div
                id="about"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                    ? { color: getPrimaryColor(), background: getAlphaPrimaryColor() }
                    : { color: '#0F1734' }
                "
                @click="
                  () => {
                    selectedTab = 'Reviews & More'
                    $router.push({ name: 'HospViewAbout' })
                  }
                "
              >
                About
              </div>
              <div
                v-if="viewUser.role !== 'nfp_administrator'"
                :style="$route.path.includes('receivedreviews') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
                id="receivedreviews"
                :class="$route.path.includes('receivedreviews') ? 'active-tabs cp' : 'tabs cp'"
                @click="
                  () => {
                    selectedTab = 'Reviews & More'
                    $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/receivedreviews/all` })
                  }
                "
              >
                Received Reviews
              </div>
              <!-- <div
                id="about"
                :class="
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? 'active-tabs cp'
                    : 'tabs cp'
                "
                :style="
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? {
                        color: getPrimaryColor(),
                        background: getAlphaPrimaryColor()
                      }
                    : { color: '#0F1734' }
                "
                @click="()=>{
                  selectedTab='Reviews & More'
                  $router.push({  name: 'HopsViewDoveDaily' })
                }"
              >
                DoveDaily
              </div> -->
              <!-- <div
                :class="
                    this.$route.path.includes('allCircleMembers')||
                    this.$route.path.includes('self')||
                    this.$route.path.includes('hospitals')||
                    this.$route.path.includes('clinics')||
                    this.$route.path.includes('nfp')||
                    this.$route.path.includes('hcp')||
                    this.$route.path.includes('providers') 
                ?'active-tabs':'tabs'"
                :style="
                  this.$route.path.includes('ViewAllCircle')||
                  this.$route.path.includes('self') ||
                  this.$route.path.includes('hospitals') ||
                  this.$route.path.includes('clinics') ||
                  this.$route.path.includes('nfp') ||
                  this.$route.path.includes('hcp') ||
                  this.$route.path.includes('providers')
                    ? {
                        color: getPrimaryColor(),
                        background: getAlphaPrimaryColor()
                      }
                    : { color: '#0F1734' }
                "
                @click="()=>{
                  selectedTab='Reviews & More'
                  $router.push({
                  path: `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id ||
                    viewUser.ext_ref_id}/circles/ViewAllCircle`
                })
                }" 
              >
              Circles
              </div> -->
              <!-- <div>
                <a-dropdown :trigger="['click']">
                  <div :style="
                        this.$route.path.includes('muteduser')||
                        this.$route.path.includes('qa')||
                        this.$route.path.includes('polls')||
                        this.$route.path.includes('saved')||
                        this.$route.path.includes('profilerev')||
                        this.$route.path.includes('medrev')||
                        this.$route.path.includes('profilercmnd')||
                        this.$route.path.includes('treatmentrcmnd') 
                          ? {color: getPrimaryColor(), background: getPrimary50Color() }
                          : {color: '#0F1734'}
                      "
                      id="reviews" 
                      :class="
                        this.$route.path.includes('muteduser')||
                        this.$route.path.includes('qa')||
                        this.$route.path.includes('polls')||
                        this.$route.path.includes('saved')||
                        this.$route.path.includes('profilerev')||
                        this.$route.path.includes('medrev')||
                        this.$route.path.includes('profilercmnd')||
                        this.$route.path.includes('treatmentrcmnd') 
                        ?'active-tabs':'tabs'" @click="() => (displayDots2 = !displayDots2)" >
                      <div 
                      :style="
                        this.$route.path.includes('muteduser')||
                        this.$route.path.includes('qa')||
                        this.$route.path.includes('polls')||
                        this.$route.path.includes('saved')||
                        this.$route.path.includes('profilerev')||
                        this.$route.path.includes('medrev')||
                        this.$route.path.includes('profilercmnd')||
                        this.$route.path.includes('treatmentrcmnd') 
                          ? {color: getPrimaryColor()}: ''
                      "
                      class="tabe">
                        {{ selectedTab }}
                        <font-awesome-icon
                        size="1x"
                        :icon="displayDots2 ? ['far', 'angle-up']:['far', 'angle-down']"
                        class="mr-2"
                        />
                      </div>
                  </div>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item id="qa" 
                        @click="() => 
                          {
                                selectedTab='Q&A';
                                $router.push({ name: 'ViewHosQA' }) 
                          }" 
                        class="card-item" >
                      Q&A
                      </a-menu-item>
                      <a-menu-item id="polls" 
                        @click="()=>
                        {
                          selectedTab='Polls'
                          $router.push({ name: 'ViewHosPolls' })
                        }
                          " 
                        class="card-item">
                        Polls
                      </a-menu-item>
                      <a-menu-item id="saved" @click="()=>
                      {
                        selectedTab='Saved';
                        $router.push({ name: 'ViewHosFav' })
                      }"
                        class="card-item" >
                        Saved
                      </a-menu-item>
                      <a-menu-item id="medrev" @click="()=>
                      {
                        selectedTab='Medication Reviews'
                        $router.push({ name: 'hospitalMedReview' })
                      }" class="card-item" >
                        Medication Reviews
                      </a-menu-item>
                      <a-menu-item id="treatmentrcmnd" @click="()=>
                      {
                        selectedTab='Treatment Recommendations'
                        $router.push({ name: 'hospitalTreatmentRec'})
                      }" class="card-item" >
                        Treatment Recommendations
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div> -->
            </div>
            <div v-if="entityType === 'clinic'" class="mt-1 profile-tabs">
              <div
                id="updates"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                    ? { color: getPrimaryColor(), background: getAlphaPrimaryColor() }
                    : { color: '#0F1734' }
                "
                @click="$router.push({ name: 'ClinicViewUpdate' })"
              >
                Updates
              </div>
              <div
                id="about"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                    ? { color: getPrimaryColor(), background: getAlphaPrimaryColor() }
                    : { color: '#0F1734' }
                "
                @click="$router.push({ name: 'ClinicViewAbout' })"
              >
                About
              </div>
              <div
                v-if="viewUser.role !== 'nfp_administrator'"
                :style="$route.path.includes('receivedreviews') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
                id="receivedreviews"
                :class="$route.path.includes('receivedreviews') ? 'active-tabs cp' : 'tabs cp'"
                @click="
                  () => {
                    selectedTab = 'Reviews & More'
                    $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/receivedreviews/all` })
                  }
                "
              >
                Received Reviews
              </div>
              <!-- <div
                id="about"
                :class="
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? 'active-tabs cp'
                    : 'tabs cp'
                "
                :style="
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? {
                        color: getPrimaryColor(),
                        background: getAlphaPrimaryColor()
                      }
                    : { color: '#0F1734' }
                "
                @click="()=>{
                  selectedTab='Reviews & More'
                  $router.push({  name: 'ClinicViewDoveDaily' })
                }"
              >
                DoveDaily
              </div>
              <div
              :class="  this.$route.path.includes('Circles')||
                    this.$route.path.includes('allCircleMembers')||
                    this.$route.path.includes('self')||
                    this.$route.path.includes('hospitals')||
                    this.$route.path.includes('clinics')||
                    this.$route.path.includes('nfp')||
                    this.$route.path.includes('hcp')||
                    this.$route.path.includes('providers') 
                ?'active-tabs':'tabs'"
                :style="
                  this.$route.path.includes('Circles')||
                  this.$route.path.includes('ViewAllCircle')||
                  this.$route.path.includes('self') ||
                  this.$route.path.includes('hospitals') ||
                  this.$route.path.includes('clinics') ||
                  this.$route.path.includes('nfp') ||
                  this.$route.path.includes('hcp') ||
                  this.$route.path.includes('providers')
                    ? {
                        color: getPrimaryColor(),
                        background: getAlphaPrimaryColor()
                      }
                    : { color: '#0F1734' }
                "
                @click="
                  $router.push({
                  path: `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id ||
                    viewUser.ext_ref_id}/circles/ViewAllCircle`
                })"
              >
                  Circles
              </div>
              <div>
                <a-dropdown :trigger="['click']">
                  <div :style="
                        this.$route.path.includes('muteduser')||
                        this.$route.path.includes('qa')||
                        this.$route.path.includes('polls')||
                        this.$route.path.includes('favourites')||
                        this.$route.path.includes('profilerev')||
                        this.$route.path.includes('medrev')||
                        this.$route.path.includes('profilercmnd')||
                        this.$route.path.includes('treatmentrcmnd') 
                          ? {color: getPrimaryColor(), background: getPrimary50Color() }
                          : {color: '#0F1734'}
                      "
                      id="reviews" 
                      :class="
                        this.$route.path.includes('muteduser')||
                        this.$route.path.includes('qa')||
                        this.$route.path.includes('polls')||
                        this.$route.path.includes('favourites')||
                        this.$route.path.includes('profilerev')||
                        this.$route.path.includes('medrev')||
                        this.$route.path.includes('profilercmnd')||
                        this.$route.path.includes('treatmentrcmnd') 
                        ?'active-tabs':'tabs'" @click="() => (displayDots2 = !displayDots2)" >
                      <div 
                      :style="
                      this.$route.path.includes('muteduser')||
                        this.$route.path.includes('qa')||
                        this.$route.path.includes('polls')||
                        this.$route.path.includes('saved')||
                        this.$route.path.includes('profilerev')||
                        this.$route.path.includes('medrev')||
                        this.$route.path.includes('profilercmnd')||
                        this.$route.path.includes('treatmentrcmnd') 
                          ? {color: getPrimaryColor()}: ''
                      "
                      class="tabe">
                        {{ selectedTab }}
                        <font-awesome-icon
                        size="1x"
                        :icon="displayDots2 ? ['far', 'angle-up']:['far', 'angle-down']"
                        class="mr-2"
                        />
                      </div>
                  </div>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item id="qa" 
                        @click="() => 
                          {
                                selectedTab='Q&A';
                                $router.push({ name: 'ClinicViewQA' }) 
                          }" 
                        class="card-item" >
                      Q&A
                      </a-menu-item>
                      <a-menu-item id="polls" 
                        @click="()=>
                        {
                          selectedTab='Polls'
                          $router.push({ name: 'ClinicViewPolls' })
                        }
                          " 
                        class="card-item">
                        Polls
                      </a-menu-item>
                      <a-menu-item id="saved" @click="()=>
                      {
                        selectedTab='Saved';
                        $router.push({ name: 'ClinicViewFavourites' })
                      }"
                        class="card-item" >
                        Saved
                      </a-menu-item>
                      <a-menu-item id="medrev" @click="()=>
                      {
                        selectedTab='Medication Reviews'
                        $router.push({ name: 'clinicMedReview' })
                      }" class="card-item" >
                        Medication Reviews
                      </a-menu-item>
                      <a-menu-item id="treatmentrcmnd" @click="()=>
                      {
                        selectedTab='Treatment Recommendations'
                        $router.push({ name: 'clinicTreatmentRec'})
                      }" class="card-item" >
                        Treatment Recommendations
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- mobile view -->
      <div class="circle-card m-prof position-relative">
        <div class="circle-card-content text-center position-relative">
          <div>
            <button class="threedot-menu mob" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => $refs.drawerShareRef.show()">
              <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
            </button>
            <a-avatar
              :size="150"
              :src="entityType === 'hospital' ? (profileData[`${entityType}_info`].picture ? profileData[`${entityType}_info`].picture : defaultHospitalImage) : defaultClinicImage"
              class="text-capitalize"
            >
            </a-avatar>
            <div class="d-flex flex-row" :style="{ 'margin-top': '26px' }">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                  fill="#00C853"
                />
                <path
                  d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                  stroke="white"
                  stroke-width="2.08333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">
                Verified and Claimed
              </p>
            </div>
          </div>
        </div>
        <div class="doc-info">
          <p class="m-0 doc-name text-capitalize" v-if="profileData[`${entityType}_info`]">
            {{ profileData[`${entityType}_info`][`${entityType}_name`] }}
          </p>
          <div class="tag-cont">
            <div class="physician-tag">
              <font-awesome-icon v-if="viewUser.role === 'hcp'" class="tag-icon-oran" :icon="['far', 'user-nurse']" :style="{ color: getPrimaryColor() }" />
              <font-awesome-icon v-if="viewUser.role === 'nfp_administrator'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ color: getPrimaryColor() }" />
              <svg v-if="viewUser.role === 'hospital'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.53906 9.67448H3.6276C3.4681 9.67448 3.35417 9.8112 3.35417 9.94792V10.8594C3.35417 11.0189 3.4681 11.1328 3.6276 11.1328H4.53906C4.67578 11.1328 4.8125 11.0189 4.8125 10.8594V9.94792C4.8125 9.8112 4.67578 9.67448 4.53906 9.67448ZM7.45573 9.67448H6.54427C6.38477 9.67448 6.27083 9.8112 6.27083 9.94792V10.8594C6.27083 11.0189 6.38477 11.1328 6.54427 11.1328H7.45573C7.59245 11.1328 7.72917 11.0189 7.72917 10.8594V9.94792C7.72917 9.8112 7.59245 9.67448 7.45573 9.67448ZM4.53906 7.48698H3.6276C3.4681 7.48698 3.35417 7.6237 3.35417 7.76042V8.67188C3.35417 8.83138 3.4681 8.94531 3.6276 8.94531H4.53906C4.67578 8.94531 4.8125 8.83138 4.8125 8.67188V7.76042C4.8125 7.6237 4.67578 7.48698 4.53906 7.48698ZM7.45573 7.48698H6.54427C6.38477 7.48698 6.27083 7.6237 6.27083 7.76042V8.67188C6.27083 8.83138 6.38477 8.94531 6.54427 8.94531H7.45573C7.59245 8.94531 7.72917 8.83138 7.72917 8.67188V7.76042C7.72917 7.6237 7.59245 7.48698 7.45573 7.48698ZM10.3724 7.48698H9.46094C9.30143 7.48698 9.1875 7.6237 9.1875 7.76042V8.67188C9.1875 8.83138 9.30143 8.94531 9.46094 8.94531H10.3724C10.5091 8.94531 10.6458 8.83138 10.6458 8.67188V7.76042C10.6458 7.6237 10.5091 7.48698 10.3724 7.48698ZM12.1042 2.38281H11.375V1.67643C11.375 0.85612 10.7142 0.195312 9.91667 0.195312H4.06055C3.26302 0.195312 2.60221 0.85612 2.60221 1.67643V2.38281H1.89583C1.07552 2.38281 0.4375 3.04362 0.4375 3.84115V11.3151C0.4375 11.6341 0.665365 11.862 0.984375 11.862C1.2806 11.862 1.53125 11.6341 1.53125 11.3151V3.84115C1.53125 3.65885 1.69076 3.47656 1.89583 3.47656H3.69596V1.67643C3.69596 1.47135 3.85547 1.28906 4.06055 1.28906H9.91667C10.1217 1.28906 10.2812 1.47135 10.2812 1.67643V3.47656H12.1042C12.2865 3.47656 12.4688 3.65885 12.4688 3.84115V11.3151C12.4688 11.6341 12.6966 11.862 13.0156 11.862C13.3118 11.862 13.5625 11.6341 13.5625 11.3151V3.84115C13.5625 3.04362 12.9017 2.38281 12.1042 2.38281ZM10.3724 9.67448H9.46094C9.30143 9.67448 9.1875 9.8112 9.1875 9.94792V10.8594C9.1875 11.0189 9.30143 11.1328 9.46094 11.1328H10.3724C10.5091 11.1328 10.6458 11.0189 10.6458 10.8594V9.94792C10.6458 9.8112 10.5091 9.67448 10.3724 9.67448ZM8.57227 3.47656H7.72917V2.63346C7.72917 2.49674 7.61523 2.38281 7.47852 2.38281H6.4987C6.36198 2.38281 6.27083 2.49674 6.27083 2.63346V3.47656H5.40495C5.26823 3.47656 5.17708 3.5905 5.17708 3.72721V4.70703C5.17708 4.84375 5.26823 4.9349 5.40495 4.9349H6.27083V5.80078C6.27083 5.9375 6.36198 6.02865 6.4987 6.02865H7.47852C7.61523 6.02865 7.72917 5.9375 7.72917 5.80078V4.9349H8.57227C8.70898 4.9349 8.82292 4.84375 8.82292 4.70703V3.72721C8.82292 3.5905 8.70898 3.47656 8.57227 3.47656Z"
                />
              </svg>
              <svg v-if="viewUser.role === 'clinic'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.45833 4.2513V3.45378C6.45833 3.36263 6.36719 3.27148 6.25325 3.27148H5.56966V2.58789C5.56966 2.47396 5.47852 2.38281 5.38737 2.38281H4.58984C4.4987 2.38281 4.40755 2.47396 4.40755 2.58789V3.27148H3.72396C3.61003 3.27148 3.54167 3.36263 3.54167 3.45378V4.2513C3.54167 4.34245 3.61003 4.43359 3.72396 4.43359H4.40755V5.11719C4.40755 5.23112 4.4987 5.29948 4.58984 5.29948H5.38737C5.47852 5.29948 5.56966 5.23112 5.56966 5.11719V4.43359H6.25325C6.36719 4.43359 6.45833 4.34245 6.45833 4.2513ZM3.9974 6.75781H3.08594C2.92643 6.75781 2.8125 6.89453 2.8125 7.03125V7.94271C2.8125 8.10221 2.92643 8.21615 3.08594 8.21615H3.9974C4.13411 8.21615 4.27083 8.10221 4.27083 7.94271V7.03125C4.27083 6.89453 4.13411 6.75781 3.9974 6.75781ZM3.9974 8.94531H3.08594C2.92643 8.94531 2.8125 9.08203 2.8125 9.21875V10.1302C2.8125 10.2897 2.92643 10.4036 3.08594 10.4036H3.9974C4.13411 10.4036 4.27083 10.2897 4.27083 10.1302V9.21875C4.27083 9.08203 4.13411 8.94531 3.9974 8.94531ZM7.91667 0.195312H2.08333C1.26302 0.195312 0.625 0.85612 0.625 1.65365V11.3151C0.625 11.6341 0.852865 11.862 1.17188 11.862C1.4681 11.862 1.71875 11.6341 1.71875 11.3151V1.65365C1.71875 1.47135 1.87826 1.28906 2.08333 1.28906H7.91667C8.09896 1.28906 8.28125 1.47135 8.28125 1.65365V11.3151C8.28125 11.6341 8.50911 11.862 8.82812 11.862C9.12435 11.862 9.375 11.6341 9.375 11.3151V1.65365C9.375 0.85612 8.71419 0.195312 7.91667 0.195312ZM6.91406 6.75781H6.0026C5.8431 6.75781 5.72917 6.89453 5.72917 7.03125V7.94271C5.72917 8.10221 5.8431 8.21615 6.0026 8.21615H6.91406C7.05078 8.21615 7.1875 8.10221 7.1875 7.94271V7.03125C7.1875 6.89453 7.05078 6.75781 6.91406 6.75781ZM6.91406 8.94531H6.0026C5.8431 8.94531 5.72917 9.08203 5.72917 9.21875V10.1302C5.72917 10.2897 5.8431 10.4036 6.0026 10.4036H6.91406C7.05078 10.4036 7.1875 10.2897 7.1875 10.1302V9.21875C7.1875 9.08203 7.05078 8.94531 6.91406 8.94531Z"
                />
              </svg>
              <div>
                {{
                  viewUser.role === "doctor"
                    ? "Physician"
                    : viewUser.role === "hospital_administrator"
                    ? "Hospital"
                    : viewUser.role === "clinic_administrator"
                    ? "clinic"
                    : viewUser.role === "nfp_administrator"
                    ? "Non-For-Profit"
                    : viewUser.role === "hcp"
                    ? "Advanced Medical Professional"
                    : viewUser.role
                }}
              </div>
            </div>
            <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="profileData[`${entityType}_info`]">
              {{ profileData[`${entityType}_info`][`${entityType}_type_desc`] }}
            </div>
          </div>
          <p :style="{ 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', color: '#0F1734', 'white-space': 'inherit !important' }" class="m-0 doc-loc text-truncate loc">
            <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
            {{ profileData[`${entityType}_info`].address.street ? profileData[`${entityType}_info`].address.street + "," : "" }}
            {{ profileData[`${entityType}_info`].address.city ? profileData[`${entityType}_info`].address.city + "," : "" }}
            {{ profileData[`${entityType}_info`].address.state ? profileData[`${entityType}_info`].address.state + "," : "" }}
            {{ profileData[`${entityType}_info`].address.zipcode ? profileData[`${entityType}_info`].address.zipcode : "" }}
          </p>
          <p :style="{ 'margin-bottom': '0px' }" class="d-flex">
            <ReviewStar :rating="totalRating.toFixed(2)" />
          </p>

          <p :style="{ 'font-weight': '400', 'font-size': '14px', 'line-height': '21px', color: '#0F1734', 'margin-top': '6px !important' }">
            {{ totalRating.toFixed(2) }} stars -
            {{ totalRevCount }}
            <!-- {{ viewUser.review_count ? viewUser.review_count : 0 }} -->
            reviews
          </p>
          <div class="stat-cont">
            <div class="statistics">
              <div class="circle-mem">
                <span class="num">{{ viewUser.no_of_recommendations || viewUser.recommendation_count || 0 }}</span>
                <span class="num-text">Recommendations</span>
              </div>
              <div class="vertical-seperator"></div>
              <div class="circle-on">
                <span class="num">{{ totalRevCount }}</span>
                <!-- <span class="num">{{ viewUser.review_count ? viewUser.review_count : 0 }}</span> -->
                <span class="num-text">Reviews</span>
              </div>
            </div>

            <!-- <div class="statistics">
            <div class="circle-mem">
              <span class="num">{{ viewUser.no_of_members ? viewUser.no_of_members : "0" }}</span>
              <span class="num-text">Circle Members</span>
            </div>
            <div class="vertical-seperator"></div>
            <div class="circle-on">
              <span class="num"> 0</span>
              <span class="num-text">Circle On</span>
            </div>
          </div> -->
          </div>
        </div>
        <div class="circle-card-footer">
          <div class="w-100 text-center d-flex justify-content-center">
            <div class="btns" :style="{ marginTop: '40px' }">
              <div class="d-flex flex-row w-100">
                <div class="d-flex flex-row w-100">
                  <!-- <button
                    class="font-white  primary-button review-btns"
                    :style="{
                      background: getPrimaryColor(),
                      cursor: 'pointer'
                    }"
                    @click="() => $refs.MessageUserModal.ShowModal(viewUser)"
                  >
                    Message
                  </button> -->
                  <!-- <div
                    class="w-100"
                    v-if="
                      ((viewUser.role === 'doctor' || viewUser.role === 'hcp') &&
                        (authUser.user.role === 'hcp' ||
                          authUser.user.role === 'hospital_administrator' ||
                          authUser.user.role === 'clinic_administrator' ||
                          authUser.user.role === 'nfp_administrator')) ||
                      ((viewUser.role === 'hcp' ||
                        viewUser.role === 'hospital_administrator' ||
                        viewUser.role === 'hospital' ||
                        viewUser.role === 'clinic' ||
                        viewUser.role === 'clinic_administrator' ||
                        viewUser.role === 'nfp_administrator') &&
                        (authUser.user.role === 'doctor' || authUser.user.role === 'hcp'))
                    "
                  > -->
                  <div class="w-100" v-if="!canReview(viewUser.role)">
                    <button
                      class="font-white primary-button review-btns"
                      :style="{ background: this.DocRecommend ? getSecondaryColor() : getPrimaryColor(), cursor: this.DocRecommend ? 'default' : 'pointer', display: 'flex', 'flex-direction': 'row' }"
                      :disabled="this.DocRecommend"
                      @click="handleRecomendPhysician"
                    >
                      <i class="fa fa-check" aria-hidden="true" v-if="this.DocRecommend" :style="{ ' margin-left': '-7px', 'padding-top': '4px', 'padding-right': ' 6px' }" />
                      {{ this.DocRecommend ? "Recommended" : "Recommend" }}
                    </button>
                  </div>
                  <div class="w-100" v-else>
                    <button
                      class="font-white primary-button review-btns"
                      :style="{ background: viewUser.recommend ? getSecondaryColor() : getPrimaryColor(), cursor: viewUser.recommend ? 'default' : 'pointer' }"
                      @click="() => handlereview(viewUser)"
                    >
                      <i class="fa fa-check" aria-hidden="true" v-if="viewUser.recommend" />
                      {{ viewUser.recommend ? "Reviewed" : "Review" }}
                    </button>
                  </div>
                </div>
              </div>

              <a-button
                :loading="loadingbtn"
                class="font-white primary-button mt-3 circle-btn"
                :style="{ background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': viewUser.on_circle ? 'none' : 'all' }"
                @click="!viewUser.on_circle && addToCircle()"
              >
                {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
              </a-button>
            </div>
          </div>
        </div>
      </div>

      <div class="m-prof-sub">
        <ul v-if="entityType === 'hospital'" class="sub-nav text-center" :style="{ display: 'flex' }">
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs' : 'tabs'"
            @click="
              () => {
                selectedTab = 'Reviews & More'
                $router.push({ name: 'HospViewUpdate' })
              }
            "
          >
            Updates
          </li>
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs' : 'tabs'"
            @click="
              () => {
                selectedTab = 'Reviews & More'
                $router.push({ name: 'HospViewAbout' })
              }
            "
          >
            About
          </li>
          <!-- <li 
          :style="
                this.$route.path===`/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                  ? {color: getPrimaryColor(), background: getPrimary50Color() }
                  : {color: '#0F1734'}
              "
          id="about" :class="this.$route.path===`/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily`?'active-tabs':'tabs'" 
          @click="()=>{
            selectedTab='Reviews & More'
            $router.push({name: 'HopsViewDoveDaily'})
           }">
          Dovedaily
         </li>
          <li 
          :style="this.$route.path.includes('ViewAllCircle')||
                  this.$route.path.includes('allCircleMembers')||
                  this.$route.path.includes('self')||
                  this.$route.path.includes('hospitals')||
                  this.$route.path.includes('clinics')||
                  this.$route.path.includes('nfp')||
                  this.$route.path.includes('hcp')||
                  this.$route.path.includes('providers') 
                  ? {color: getPrimaryColor(), background: getPrimary50Color() }
                  : {color: '#0F1734'}
              "
              id="circles"
              :class="
                  this.$route.path.includes('ViewAllCircle')||
                  this.$route.path.includes('allCircleMembers')||
                  this.$route.path.includes('self')||
                  this.$route.path.includes('hospitals')||
                  this.$route.path.includes('clinics')||
                  this.$route.path.includes('nfp')||
                  this.$route.path.includes('hcp')||
                  this.$route.path.includes('providers') 
              ?'active-tabs':'tabs'" 
               @click="()=>{
                selectedTab='Reviews & More'
                $router.push({
              path: `/${currentCircle.key_name}/profile/view/${
                viewUser.role
              }/${viewUser.id ||
                viewUser.ext_ref_id}/circles/ViewAllCircle`
            })
              }"
              >
            Circles
          </li>
          <a-dropdown :trigger="['click']">
              <div :style="
                    this.$route.path.includes('muteduser')||
                    this.$route.path.includes('qa')||
                    this.$route.path.includes('polls')||
                    this.$route.path.includes('saved')||
                    this.$route.path.includes('profilerev')||
                    this.$route.path.includes('medrev')||
                    this.$route.path.includes('profilercmnd')||
                    this.$route.path.includes('treatmentrcmnd') 
                      ? {color: getPrimaryColor(), background: getPrimary50Color() }
                      : {color: '#0F1734'}
                  "
                  id="reviews" 
                  :class="
                    this.$route.path.includes('muteduser')||
                    this.$route.path.includes('qa')||
                    this.$route.path.includes('polls')||
                    this.$route.path.includes('saved')||
                    this.$route.path.includes('profilerev')||
                    this.$route.path.includes('medrev')||
                    this.$route.path.includes('profilercmnd')||
                    this.$route.path.includes('treatmentrcmnd') 
                    ?'active-tabs':'tabs'" @click="() => (displayDots2 = !displayDots2)" >
                  <div 
                  :style="
                    this.$route.path.includes('muteduser')||
                    this.$route.path.includes('qa')||
                    this.$route.path.includes('polls')||
                    this.$route.path.includes('saved')||
                    this.$route.path.includes('profilerev')||
                    this.$route.path.includes('medrev')||
                    this.$route.path.includes('profilercmnd')||
                    this.$route.path.includes('treatmentrcmnd') 
                      ? {color: getPrimaryColor()}: ''
                  "
                  class="tabe">
                    {{ selectedTab }}
                    <font-awesome-icon
                    size="1x"
                    :icon="displayDots2 ? ['far', 'angle-up']:['far', 'angle-down']"
                    class="mr-2"
                    />
                  </div>
              </div>
              <template #overlay>
                <a-menu>
                  <a-menu-item id="qa" 
                    @click="() => 
                      {
                            selectedTab='Q&A';
                            $router.push({ name: 'ViewHosQA' }) 
                      }" 
                    class="card-item" >
                  Q&A
                  </a-menu-item>
                  <a-menu-item id="polls" 
                    @click="()=>
                    {
                      selectedTab='Polls'
                      $router.push({ name: 'ViewHosPolls' })
                    }
                      " 
                    class="card-item">
                    Polls
                  </a-menu-item>
                  <a-menu-item id="saved" @click="()=>
                  {
                    selectedTab='Saved';
                    $router.push({ name: 'ViewHosFav' })
                  }"
                    class="card-item" >
                    Saved
                  </a-menu-item>
                  <a-menu-item id="medrev" @click="()=>
                  {
                    selectedTab='Medication Reviews'
                    $router.push({ name: 'hospitalMedReview' })
                  }" class="card-item" >
                    Medication Reviews
                  </a-menu-item>
                  <a-menu-item id="treatmentrcmnd" @click="()=>
                  {
                    selectedTab='Treatment Recommendations'
                    $router.push({ name: 'hospitalTreatmentRec'})
                  }" class="card-item" >
                    Treatment Recommendations
                  </a-menu-item>
                </a-menu>
              </template>
          </a-dropdown> -->
        </ul>
        <ul v-if="entityType === 'clinic'" class="sub-nav text-center" :style="{ display: 'flex' }">
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs' : 'tabs'"
            @click="
              () => {
                selectedTab = 'Reviews & More'
                $router.push({ name: 'ClinicViewUpdate' })
              }
            "
          >
            Updates
          </li>
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs' : 'tabs'"
            @click="
              () => {
                selectedTab = 'Reviews & More'
                $router.push({ name: 'ClinicViewAbout' })
              }
            "
          >
            About
          </li>
          <!-- <li 
          :style="
                this.$route.path===`/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                  ? {color: getPrimaryColor(), background: getPrimary50Color() }
                  : {color: '#0F1734'}
              "
          id="about" :class="this.$route.path===`/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily`?'active-tabs':'tabs'" 
          @click="()=>{
                selectedTab='Reviews & More'
                $router.push({name: 'ClinicViewDoveDaily'})
              }">
          Dovedaily
         </li>
          <li 
          :style="this.$route.path.includes('ViewAllCircle')||
                  this.$route.path.includes('allCircleMembers')||
                  this.$route.path.includes('self')||
                  this.$route.path.includes('hospitals')||
                  this.$route.path.includes('clinics')||
                  this.$route.path.includes('nfp')||
                  this.$route.path.includes('hcp')||
                  this.$route.path.includes('providers') 
                  ? {color: getPrimaryColor(), background: getPrimary50Color() }
                  : {color: '#0F1734'}
              "
              id="circles"
              :class="
                  this.$route.path.includes('ViewAllCircle')||
                  this.$route.path.includes('allCircleMembers')||
                  this.$route.path.includes('self')||
                  this.$route.path.includes('hospitals')||
                  this.$route.path.includes('clinics')||
                  this.$route.path.includes('nfp')||
                  this.$route.path.includes('hcp')||
                  this.$route.path.includes('providers') 
              ?'active-tabs':'tabs'"
                 @click="()=>{
                selectedTab='Reviews & More'
                $router.push({
                  path: `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id ||
                    viewUser.ext_ref_id}/circles/ViewAllCircle`
                })
              }">
            Circles
          </li>
            <a-dropdown :trigger="['click']">
              <div :style="
                    this.$route.path.includes('qa')||
                    this.$route.path.includes('polls')||
                    this.$route.path.includes('favourites')||
                    this.$route.path.includes('profilerev')||
                    this.$route.path.includes('medrev')||
                    this.$route.path.includes('profilercmnd')||
                    this.$route.path.includes('treatmentrcmnd') 
                      ? {color: getPrimaryColor(), background: getPrimary50Color() }
                      : {color: '#0F1734'}
                  "
                  id="reviews" 
                  :class="
                    this.$route.path.includes('qa')||
                    this.$route.path.includes('polls')||
                    this.$route.path.includes('favourites')||
                    this.$route.path.includes('profilerev')||
                    this.$route.path.includes('medrev')||
                    this.$route.path.includes('profilercmnd')||
                    this.$route.path.includes('treatmentrcmnd') 
                    ?'active-tabs':'tabs'" @click="() => (displayDots2 = !displayDots2)" >
                  <div 
                  :style="
                    this.$route.path.includes('qa')||
                    this.$route.path.includes('polls')||
                    this.$route.path.includes('saved')||
                    this.$route.path.includes('profilerev')||
                    this.$route.path.includes('medrev')||
                    this.$route.path.includes('profilercmnd')||
                    this.$route.path.includes('treatmentrcmnd') 
                      ? {color: getPrimaryColor()}: ''
                  "
                  class="tabe">
                    {{ selectedTab }}
                    <font-awesome-icon
                    size="1x"
                    :icon="displayDots2 ? ['far', 'angle-up']:['far', 'angle-down']"
                    class="mr-2"
                    />
                  </div>
              </div>
              <template #overlay>
                <a-menu>
                  <a-menu-item id="qa" 
                    @click="() => 
                      {
                            selectedTab='Q&A';
                            $router.push({ name: 'ClinicViewQA' }) 
                      }" 
                    class="card-item" >
                  Q&A
                  </a-menu-item>
                  <a-menu-item id="polls" 
                    @click="()=>
                    {
                      selectedTab='Polls'
                      $router.push({ name: 'ClinicViewPolls' })
                    }
                      " 
                    class="card-item">
                    Polls
                  </a-menu-item>
                  <a-menu-item id="saved" @click="()=>
                  {
                    selectedTab='Saved';
                    $router.push({ name: 'ClinicViewFavourites' })
                  }"
                    class="card-item" >
                    Saved
                  </a-menu-item>
                  <a-menu-item id="medrev" @click="()=>
                  {
                    selectedTab='Medication Reviews'
                    $router.push({ name: 'clinicMedReview' })
                  }" class="card-item" >
                    Medication Reviews
                  </a-menu-item>
                  <a-menu-item id="treatmentrcmnd" @click="()=>
                  {
                    selectedTab='Treatment Recommendations'
                    $router.push({ name: 'clinicTreatmentRec'})
                  }" class="card-item" >
                    Treatment Recommendations
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown> -->
        </ul>
      </div>

      <!-- Web view -->
      <div class="dovemed-wrapper m-prof-wrapper py-4 padding-fix">
        <div class="row">
          <div class="col-md-4 col-lg-4 d-prof-progress">
            <div class="d-flex phy-profile-card-container">
              <button class="threedot-menu" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="showOptions">
                <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
                <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
                  <p class="card-item" @click="saveToDirectory">
                    <font-awesome-icon :icon="[`${profileData.saved ? 'fas' : 'fal'}`, 'bookmark']" class="mr-2" />
                    {{ profileData.saved ? "Saved to DoveDirectory" : "Save to DoveDirectory" }}
                  </p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.ShareProfileModal.showModal()
                      }
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path
                        d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                        fill="black"
                      /></svg
                    >Share Profile
                  </p>
                  <p class="divider"></p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.reportContentModal.show({ id: this.viewUser.id }, 15, this.viewUser.role)
                      }
                    "
                  >
                    <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2" />
                    Report
                  </p>
                </div>
              </button>

              <div class="profile-image mr-3 position-relative">
                <a-avatar
                  :size="150"
                  :src="entityType === 'hospital' ? (profileData[`${entityType}_info`].picture ? profileData[`${entityType}_info`].picture : defaultHospitalImage) : defaultClinicImage"
                  class="text-capitalize"
                >
                </a-avatar>
              </div>
              <div class="d-flex flex-row" :style="{ 'margin-top': '26px' }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                    fill="#00C853"
                  />
                  <path
                    d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                    stroke="white"
                    stroke-width="2.08333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified and Claimed</p>
              </div>

              <div class="doc-info">
                <p class="m-0 doc-name text-capitalize" v-if="profileData[`${entityType}_info`]">
                  {{ profileData[`${entityType}_info`][`${entityType}_name`] }}
                </p>
                <div class="tag-cont">
                  <div class="physician-tag">
                    <font-awesome-icon v-if="viewUser.role === 'hcp'" class="tag-icon-oran" :icon="['far', 'user-nurse']" :style="{ color: getPrimaryColor() }" />
                    <font-awesome-icon v-if="viewUser.role === 'nfp_administrator'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ color: getPrimaryColor() }" />
                    <svg v-if="viewUser.role === 'hospital'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.53906 9.67448H3.6276C3.4681 9.67448 3.35417 9.8112 3.35417 9.94792V10.8594C3.35417 11.0189 3.4681 11.1328 3.6276 11.1328H4.53906C4.67578 11.1328 4.8125 11.0189 4.8125 10.8594V9.94792C4.8125 9.8112 4.67578 9.67448 4.53906 9.67448ZM7.45573 9.67448H6.54427C6.38477 9.67448 6.27083 9.8112 6.27083 9.94792V10.8594C6.27083 11.0189 6.38477 11.1328 6.54427 11.1328H7.45573C7.59245 11.1328 7.72917 11.0189 7.72917 10.8594V9.94792C7.72917 9.8112 7.59245 9.67448 7.45573 9.67448ZM4.53906 7.48698H3.6276C3.4681 7.48698 3.35417 7.6237 3.35417 7.76042V8.67188C3.35417 8.83138 3.4681 8.94531 3.6276 8.94531H4.53906C4.67578 8.94531 4.8125 8.83138 4.8125 8.67188V7.76042C4.8125 7.6237 4.67578 7.48698 4.53906 7.48698ZM7.45573 7.48698H6.54427C6.38477 7.48698 6.27083 7.6237 6.27083 7.76042V8.67188C6.27083 8.83138 6.38477 8.94531 6.54427 8.94531H7.45573C7.59245 8.94531 7.72917 8.83138 7.72917 8.67188V7.76042C7.72917 7.6237 7.59245 7.48698 7.45573 7.48698ZM10.3724 7.48698H9.46094C9.30143 7.48698 9.1875 7.6237 9.1875 7.76042V8.67188C9.1875 8.83138 9.30143 8.94531 9.46094 8.94531H10.3724C10.5091 8.94531 10.6458 8.83138 10.6458 8.67188V7.76042C10.6458 7.6237 10.5091 7.48698 10.3724 7.48698ZM12.1042 2.38281H11.375V1.67643C11.375 0.85612 10.7142 0.195312 9.91667 0.195312H4.06055C3.26302 0.195312 2.60221 0.85612 2.60221 1.67643V2.38281H1.89583C1.07552 2.38281 0.4375 3.04362 0.4375 3.84115V11.3151C0.4375 11.6341 0.665365 11.862 0.984375 11.862C1.2806 11.862 1.53125 11.6341 1.53125 11.3151V3.84115C1.53125 3.65885 1.69076 3.47656 1.89583 3.47656H3.69596V1.67643C3.69596 1.47135 3.85547 1.28906 4.06055 1.28906H9.91667C10.1217 1.28906 10.2812 1.47135 10.2812 1.67643V3.47656H12.1042C12.2865 3.47656 12.4688 3.65885 12.4688 3.84115V11.3151C12.4688 11.6341 12.6966 11.862 13.0156 11.862C13.3118 11.862 13.5625 11.6341 13.5625 11.3151V3.84115C13.5625 3.04362 12.9017 2.38281 12.1042 2.38281ZM10.3724 9.67448H9.46094C9.30143 9.67448 9.1875 9.8112 9.1875 9.94792V10.8594C9.1875 11.0189 9.30143 11.1328 9.46094 11.1328H10.3724C10.5091 11.1328 10.6458 11.0189 10.6458 10.8594V9.94792C10.6458 9.8112 10.5091 9.67448 10.3724 9.67448ZM8.57227 3.47656H7.72917V2.63346C7.72917 2.49674 7.61523 2.38281 7.47852 2.38281H6.4987C6.36198 2.38281 6.27083 2.49674 6.27083 2.63346V3.47656H5.40495C5.26823 3.47656 5.17708 3.5905 5.17708 3.72721V4.70703C5.17708 4.84375 5.26823 4.9349 5.40495 4.9349H6.27083V5.80078C6.27083 5.9375 6.36198 6.02865 6.4987 6.02865H7.47852C7.61523 6.02865 7.72917 5.9375 7.72917 5.80078V4.9349H8.57227C8.70898 4.9349 8.82292 4.84375 8.82292 4.70703V3.72721C8.82292 3.5905 8.70898 3.47656 8.57227 3.47656Z"
                      />
                    </svg>
                    <svg v-if="viewUser.role === 'clinic'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.45833 4.2513V3.45378C6.45833 3.36263 6.36719 3.27148 6.25325 3.27148H5.56966V2.58789C5.56966 2.47396 5.47852 2.38281 5.38737 2.38281H4.58984C4.4987 2.38281 4.40755 2.47396 4.40755 2.58789V3.27148H3.72396C3.61003 3.27148 3.54167 3.36263 3.54167 3.45378V4.2513C3.54167 4.34245 3.61003 4.43359 3.72396 4.43359H4.40755V5.11719C4.40755 5.23112 4.4987 5.29948 4.58984 5.29948H5.38737C5.47852 5.29948 5.56966 5.23112 5.56966 5.11719V4.43359H6.25325C6.36719 4.43359 6.45833 4.34245 6.45833 4.2513ZM3.9974 6.75781H3.08594C2.92643 6.75781 2.8125 6.89453 2.8125 7.03125V7.94271C2.8125 8.10221 2.92643 8.21615 3.08594 8.21615H3.9974C4.13411 8.21615 4.27083 8.10221 4.27083 7.94271V7.03125C4.27083 6.89453 4.13411 6.75781 3.9974 6.75781ZM3.9974 8.94531H3.08594C2.92643 8.94531 2.8125 9.08203 2.8125 9.21875V10.1302C2.8125 10.2897 2.92643 10.4036 3.08594 10.4036H3.9974C4.13411 10.4036 4.27083 10.2897 4.27083 10.1302V9.21875C4.27083 9.08203 4.13411 8.94531 3.9974 8.94531ZM7.91667 0.195312H2.08333C1.26302 0.195312 0.625 0.85612 0.625 1.65365V11.3151C0.625 11.6341 0.852865 11.862 1.17188 11.862C1.4681 11.862 1.71875 11.6341 1.71875 11.3151V1.65365C1.71875 1.47135 1.87826 1.28906 2.08333 1.28906H7.91667C8.09896 1.28906 8.28125 1.47135 8.28125 1.65365V11.3151C8.28125 11.6341 8.50911 11.862 8.82812 11.862C9.12435 11.862 9.375 11.6341 9.375 11.3151V1.65365C9.375 0.85612 8.71419 0.195312 7.91667 0.195312ZM6.91406 6.75781H6.0026C5.8431 6.75781 5.72917 6.89453 5.72917 7.03125V7.94271C5.72917 8.10221 5.8431 8.21615 6.0026 8.21615H6.91406C7.05078 8.21615 7.1875 8.10221 7.1875 7.94271V7.03125C7.1875 6.89453 7.05078 6.75781 6.91406 6.75781ZM6.91406 8.94531H6.0026C5.8431 8.94531 5.72917 9.08203 5.72917 9.21875V10.1302C5.72917 10.2897 5.8431 10.4036 6.0026 10.4036H6.91406C7.05078 10.4036 7.1875 10.2897 7.1875 10.1302V9.21875C7.1875 9.08203 7.05078 8.94531 6.91406 8.94531Z"
                      />
                    </svg>
                    <div>
                      {{
                        viewUser.role === "doctor"
                          ? "Physician"
                          : viewUser.role === "hospital_administrator"
                          ? "Hospital"
                          : viewUser.role === "clinic_administrator"
                          ? "clinic"
                          : viewUser.role === "nfp_administrator"
                          ? "Non-For-Profit"
                          : viewUser.role === "hcp"
                          ? "Advanced Medical Professional"
                          : viewUser.role
                      }}
                    </div>
                  </div>
                  <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="profileData[`${entityType}_info`]">
                    {{ profileData[`${entityType}_info`][`${entityType}_type_desc`] }}
                  </div>
                </div>
                <p
                  :style="{ color: '#0F1734', 'line-height': '21px', 'padding-bottom': '14.5px', 'white-space': 'inherit !important' }"
                  v-if="profileData[`${entityType}_info`].address.city"
                  class="m-0 doc-loc text-truncate fw700 font14"
                >
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                  {{ profileData[`${entityType}_info`].address.street ? profileData[`${entityType}_info`].address.street + "," : "" }}
                  {{ profileData[`${entityType}_info`].address.city ? profileData[`${entityType}_info`].address.city + "," : "" }}
                  {{ profileData[`${entityType}_info`].address.state ? profileData[`${entityType}_info`].address.state + "," : "" }}
                  {{ profileData[`${entityType}_info`].address.zipcode ? profileData[`${entityType}_info`].address.zipcode : "" }}
                </p>
                <p :style="{ 'margin-bottom': '0px' }">
                  <ReviewStar :rating="totalRating.toFixed(2)" />
                </p>

                <p :style="{ 'font-weight': '400', 'font-size': '14px', 'line-height': '21px', color: '#0F1734', 'margin-top': '6px !important', 'margin-bottom': '0px !important' }">
                  {{ totalRating.toFixed(2) }} stars -
                  {{ totalRevCount }}
                  reviews
                </p>
                <!-- ==========================circle box====================================== -->

                <div class="stat-cont">
                  <div class="statistics">
                    <div class="circle-mem">
                      <span class="num">{{ viewUser.no_of_recommendations || viewUser.recommendation_count || 0 }}</span>
                      <span class="num-text">Recommendations</span>
                    </div>
                    <div class="vertical-seperator"></div>
                    <div class="circle-on">
                      <span class="num">{{ totalRevCount }}</span>
                      <span class="num-text">Reviews</span>
                    </div>
                  </div>

                  <!-- <div class="statistics">
            <div class="circle-mem">
              <span class="num">{{ viewUser.no_of_members ? viewUser.no_of_members : "0" }}</span>
              <span class="num-text">Circle Members</span>
            </div>
            <div class="vertical-seperator"></div>
            <div class="circle-on">
              <span class="num"> 0</span>
              <span class="num-text">Circle On</span>
            </div>
          </div> -->
                </div>
              </div>
              <div class="btns" :style="{ marginTop: '40px' }">
                <div class="d-flex flex-row w-100">
                  <!-- <div
                    class="w-100"
                    v-if="
                      ((viewUser.role === 'doctor' || viewUser.role === 'hcp') &&
                        (authUser.user.role === 'hcp' ||
                          authUser.user.role === 'hospital_administrator' ||
                          authUser.user.role === 'clinic_administrator' ||
                          authUser.user.role === 'nfp_administrator')) ||
                      ((viewUser.role === 'hcp' ||
                        viewUser.role === 'hospital_administrator' ||
                        viewUser.role === 'hospital' ||
                        viewUser.role === 'clinic' ||
                        viewUser.role === 'clinic_administrator' ||
                        viewUser.role === 'nfp_administrator') &&
                        (authUser.user.role === 'doctor' || authUser.user.role === 'hcp'))
                    "
                  > -->
                  <div class="w-100" v-if="!canReview(viewUser.role)">
                    <button
                      class="font-white primary-button review-btns"
                      :style="{ background: this.DocRecommend ? getSecondaryColor() : getPrimaryColor(), cursor: this.DocRecommend ? 'default' : 'pointer', display: 'flex', 'flex-direction': 'row' }"
                      :disabled="this.DocRecommend"
                      @click="handleRecomendPhysician"
                    >
                      <i class="fa fa-check" aria-hidden="true" v-if="this.DocRecommend" :style="{ ' margin-left': '-7px', 'padding-top': '4px', 'padding-right': ' 6px' }" />
                      {{ this.DocRecommend ? "Recommended" : "Recommend" }}
                    </button>
                  </div>
                  <div v-else class="w-100">
                    <button
                      class="font-white primary-button review-btns"
                      :style="{ background: viewUser.recommend ? getSecondaryColor() : getPrimaryColor(), cursor: viewUser.recommend ? 'default' : 'pointer' }"
                      @click="() => handlereview(viewUser)"
                    >
                      <i class="fa fa-check" aria-hidden="true" v-if="viewUser.recommend" />
                      {{ viewUser.recommend ? "Reviewed" : "Review" }}
                    </button>
                  </div>
                </div>

                <a-button
                  :loading="loadingbtn"
                  class="font-white primary-button mt-3 circle-btn"
                  :style="{ background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': viewUser.on_circle ? 'none' : 'all' }"
                  @click="!viewUser.on_circle && addToCircle()"
                >
                  {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
                </a-button>
              </div>
            </div>
          </div>

          <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 about-phy">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <RecommendOthersModal ref="RecommendOthersModal" :fetchUser="fetchDocData" />
    <RecommendDoctorModal ref="RecommendDoctorModal" :fetchUser="fetchDocData" />
    <AddToCircle ref="AddToCircle" />
    <MessageUserModal ref="MessageUserModal" />
    <ShareProfileModal ref="ShareProfileModal" />
    <ReportContentModal ref="reportContentModal" />
    <DrawerModal ref="drawerShareRef">
      <div @click="() => $refs.drawerShareRef.close()">
        <p class="drawer-item" @click="saveToDirectory">
          <font-awesome-icon :icon="[`${profileData.saved ? 'fas' : 'fal'}`, 'bookmark']" class="mr-2" />
          {{ profileData.saved ? "Saved to DoveDirectory" : "Save to DoveDirectory" }}
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.ShareProfileModal.showModal()
            }
          "
        >
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.reportContentModal.show({ id: this.viewUser.id }, 15, this.viewUser.role === 'hospital' ? 'hospital_administrator' : 'clinic_administrator')
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2" />
          Report
        </p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import DoctorAbout from "../view/ViewDoctorAbout"
import ReportContentModal from "../../../Modals/ReportContent.vue"
import AddToCircle from "../../../Modals/AddToCircle.vue"
import DoctorCircles from "../view/ViewDoctorCircles"
import DoctorUpdates from "../view/ViewDoctorUpdates"
import DoctorFav from "../view/ViewDoctorFavorites"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import RecommendOthersModal from "../../../Modals/RecommendOthers"
import RecommendDoctorModal from "../../../Modals/RecommendDoctor"
import ReviewStar from "../../Doctor/reviewStar.vue"
import Reviewstarforcircle from "../../Doctor/reviewstarforcircle.vue"
import ShareProfileModal from "../../../Modals/ShareProfileModal.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
import MessageUserModal from "../../../Modals/MessageUserModal"
import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons"
import { faBullhorn, faHospital, faHospitalSymbol, faHandHoldingHeart, faHandHeart, faUser, faUserMd, faHospitalAlt, faUserNurse } from "@fortawesome/pro-regular-svg-icons"
import DrawerModal from "../../../Modals/DrawerModal.vue"

library.add(faMapMarkerAlt, faAngleDown, faAngleUp, faBullhorn, faHandHoldingHeart, faUser, faUserMd, faHospitalAlt, faHospitalSymbol, faUserNurse, faHospital, faHandHeart)
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "HospitalViewProfile",
  components: {
    DoctorUpdates,
    DoctorAbout,
    DoctorCircles,
    DoctorFav,
    RecommendOthersModal,
    ReviewStar,
    Reviewstarforcircle,
    ShareProfileModal,
    RecommendDoctorModal,
    MessageUserModal,
    AddToCircle,
    ReportContentModal,
    DrawerModal,
  },
  data() {
    return {
      apiUrl: "",
      apiDoc: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/doctor_prof.json",
      apiPat: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/patient_prof.json",
      profileData: null,
      cardKeys: null,
      editableData: null,
      toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "is_verified", "npi_number", "state_licence", "licence_number"],
      displayDots2: false,
      loadingbtn: null,
      tabs: { updates: false, about: true, circles: false, qa: false, fav: false },
      selectedTab: "Reviews & More",
      activeTab: "about",
      user: null,
      displayDots: false,
      DocRecommend: false,
      entityType: "",
      tag: "",
      defaultHospitalImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Hospital.svg",
      defaultClinicImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Clinic.svg",
      totalRevCount: 0,
      totalRating: 0,
      loading: true,
    }
  },
  created() {
    let a = this.$router.history.current.fullPath.split("/")
    // console.log("this.$route:", this.$route)
    // console.log("this.$router.history.current.fullPath:", this.$router.history.current.fullPath)
    if (this.$router.history.current.fullPath.includes("receivedreviews/")) {
      this.entityType = a[a.length - 4]
    } else {
      this.entityType = a[a.length - 3]
    }
    this.fetchDocData().then(() => {
      console.warn("ViewHospitalProfile.vue is created")
      console.log("viewUser ->", this.viewUser)
      this.DocRecommend = this.viewUser.recommend
      this.loading = false
    })
  },

  computed: {
    getUserName() {
      return this.$store.getters["User/user"].display_name
    },
  },

  methods: {
    saveToDirectory() {
      if (this.profileData.saved) {
        return
      }
      let payload = {
        owner_user: this.authUser.user.id,
        owner_user_role: this.authUser.user.role,
        saved_user: this.viewUser.ext_ref_id ? this.viewUser.ext_ref_id : this.viewUser.id,
        saved_user_role: this.viewUser.role === "hospital" ? "hospital_administrator" : "clinic_administrator",
        circle_id: this.currentCircle.id,
      }
      UserRepository.SaveToDirectory(payload)
        .then(res => {
          this.$notification.success({ message: "Saved", description: `Profile saved to directory successfully` })
          this.profileData.saved = true
        })
        .catch(err => {
          this.$notification.error({ message: "Error", description: `Profile was not saved to directory` })
        })
    },

    handlereview(viewUser) {
      if (!viewUser.recommend) {
        switch (viewUser.role) {
          case "hcp":
            this.$refs.RecommendDoctorModal.show({
              ...viewUser,
              role: "hcp",
              page: 0,
              inPersonReview: viewUser.in_person_visit,
              onlineReview: viewUser.online_tele_medicine,
              myCirclesReview: viewUser.my_circle,
            })
            break

          case "doctor":
            this.$refs.RecommendDoctorModal.show({
              ...viewUser,
              role: "doctor",
              page: 0,
              inPersonReview: viewUser.in_person_visit,
              onlineReview: viewUser.online_tele_medicine,
              myCirclesReview: viewUser.my_circle,
            })
            break
          case "clinic":
            this.$refs.RecommendOthersModal.show({
              ...viewUser,
              role: "clinic",
              page: 0,
            })
            break
          case "hospital":
            this.$refs.RecommendOthersModal.show({
              ...viewUser,
              role: "hospital",
              page: 0,
            })
        }
      }
    },

    handleRecomendPhysician() {
      const payload = {
        type: "recommended",
        reviewer_id: this.authUser.user.id,
        reviewer_role: this.authUser.user.role,
        reviewee_id: this.viewUser.ext_ref_id,
        reviewee_role: this.viewUser.role === "clinic" ? "clinic_administrator" : "hospital_administrator",
        circle_id: this.currentCircle.id,
        recommended: "true",
      }
      // console.log(payload)
      UserRepository.recommendPhysician(payload)
        .then(res => {
          console.log(res, "recommended")
          this.fetchDocData()
          this.$notification.success({ message: "Success", description: "Recommended this physician successfully" })
          this.DocRecommend = true
          this.fetchDocData()
          //this.$router.go();
          //  window.location.reload();
        })
        .catch(err => {
          console.log("error", err)
        })
    },

    // handleChangeViewUserReview() {
    //   this.viewUser.recommend = true
    // },
    showOptions() {
      this.displayDots = !this.displayDots
    },

    addToCircle() {
      this.loadingbtn = true
      const data = { ...this.viewUser, ext_ref_id: this.viewUser.id }
      UserRepository.addUserByTypeToCircle(this.viewUser.ext_ref_id, this.currentCircle.id, this.viewUser.role).then(res => {
        if (this.viewUser.ext_ref_id) {
          UserRepository.getOtherEntityProfile(this.viewUser, this.currentCircle.id)
            .then(res => {
              // console.log("getOtherEntityProfile res.data ==", res.data)
              const data = { role: this.viewUser.role, on_circle: res.data.data.on_circle, ...this.viewUser }
              this.$store.commit("User/setViewUser", { data: data })
              this.viewUser.on_circle = true
              this.loadingbtn = false
              this.isCircle = true
              //   this.$notification.success({
              //   message: "Success",
              //   description: "Physician added to circle"
              // });
              if (this.viewUser.role === "doctor" || this.viewUser.role === "physician") {
                this.$refs.AddToCircle.show()
              }
              // console.log("this on circle")
            })
            .catch(err => {
              this.loadingbtn = false
            })
        } else {
          UserRepository.getOtherUserProfile(this.viewUser, this.currentCircle.id)
            .then(res => {
              // console.log("getOtherUserProfile res.data ==", res.data)
              const data = {
                ...res.data.data.user_info,
                on_circle: res.data.data.on_circle,
                request_to_add: res.data.data.request_to_add,
                recommendations: res.data.data.no_of_recommendations,
                recommend: res.data.data.recommend,
                inPersonReview: res.data.data.in_person_visit,
                onlineReview: res.data.data.online_tele_medicine,
                myCirclesReview: res.data.data.my_circle,
              }
              this.$store.commit("User/setViewUser", { data })
              this.isCircle = true
              this.loadingbtn = false
              if (this.viewUser.role === "doctor" || this.viewUser.role === "physician") {
                this.$refs.AddToCircle.show()
              }
            })
            .catch(err => {
              this.loadingbtn = false
            })
        }
      })
    },

    // handleRecomendDoctor() {
    //   if (!this.viewUser.recommend) {
    //     this.$refs.RecommendDoctorModal.show({
    //       ...this.viewUser,
    //       inPersonReview: this.viewUser.in_person_visit,
    //       onlineReview: this.viewUser.online_tele_medicine,
    //       myCirclesReview: this.viewUser.my_circle,
    //     })
    //   }
    // },

    async fetchDocData() {
      try {
        // console.log(this.$route.params.id, this.entityType)
        const data = await UserRepository.getOtherEntityProfile({ id: this.$route.params.id, role: this.entityType }, this.currentCircle.id)
        // console.log(data, "doc data")
        this.$store.commit("User/setViewUser", {
          data: { ...data.data.data, role: this.entityType, isDirectory: true },
        })
        this.profileData = data.data.data ? data.data.data : {}

        // console.log("profileData:", this.profileData)

        const profileType = this.viewUser.role
        switch (profileType) {
          case "hospital_administrator":
            this.tag = this.profileData.hospital_type
            break
          case "clinic_administrator":
            this.tag = this.profileData.clinic_type
            break
          case "nfp_administrator":
            this.tag = this.profileData.nfp_type
            break
          case "hcp":
            this.tag = this.profileData.speciality
            break
          case "doctor":
            this.tag = this.profileData.speciality
            break
        }

        let profileDataCopy = { ...this.profileData }
        this.toDeleteKeys.forEach(key => {
          delete profileDataCopy[key]
        })
        this.DocRecommend = this.viewUser.recommend
        // const keys = Object.keys(profileDataCopy)
        const keys = Object.keys(profileDataCopy)
        this.cardKeys = this.makeKeys(keys)
        this.status = true

        const headers = { Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`, dtoken: this.authUser.user.dovemed_csrf_token || this.authUser.user.dovemed_session_token }
        // const coreRes = await this.$http.get(`${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(this.viewUser.role)}/${this.viewUser.ext_ref_id || this.viewUser.id}/review/`, {
        const coreRes = await this.$http.get(`${process.env.SSO_BASE_URL}/api/v2/review/${this.getCoreReviewApiRole(this.viewUser.role)}/${this.viewUser.ext_ref_id || this.viewUser.id}/review/`, {
          headers,
        })
        this.totalRevCount = (this.profileData.no_of_reviews || this.profileData.review_count || 0) + (coreRes.data.count || 0)
        this.totalRating = this.profileData.rating
          ? this.profileData.overall_rating
            ? (this.profileData.rating + this.profileData.overall_rating) / 2
            : this.profileData.rating
          : this.profileData.overall_rating || 0
      } catch (e) {}
    },

    // swapProf() {
    //   this.apiUrl === this.apiDoc ? (this.apiUrl = this.apiPat) : (this.apiUrl = this.apiDoc)
    //   this.fetchDocData(this.apiUrl)
    // },

    // changeTab(e) {
    //   if (this.tabs.hasOwnProperty(e.target.id)) {
    //     this.tabs[this.activeTab] = false
    //     this.tabs[e.target.id] = true
    //     this.activeTab = e.target.id
    //   }
    // },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },

    // makeEditable(cardKey) {
    //   this.keys[cardKey] = true
    //   this.editableData = this.data[cardKey]
    // },

    // cancelEditable(cardKey) {
    //   this.keys[cardKey] = false
    //   this.data[cardKey] = this.editableData
    //   this.editableData = null
    // },

    // save(cardKey) {
    //   this.editableData = null
    //   this.keys[cardKey] = false
    // },
  },

  // filters: {
  //   humanize: function(value, capitalize = true) {
  //     if (!value) return ""
  //     return capitalize
  //       ? value
  //           .toLowerCase()
  //           .split("_")
  //           .map(e => e.toUpperCase())
  //           .join(" ")
  //       : value
  //           .toLowerCase()
  //           .split("_")
  //           .map(e => e.charAt(0).toUpperCase() + e.substring(1))
  //           .join(" ")
  //   },

  //   total: function(value, ...options) {
  //     if (!value) return ""
  //     return Array.isArray(value) ? `(${value.length})` : ""
  //   },
  // },
}
</script>

<style lang="scss" scoped>
.stat-cont {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 48px;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.tabs:hover {
  color: #2a71d4;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  // color: #0F1734;
}

.tabe {
  display: flex;
  gap: 5px;
  align-items: center;
  width: max-content;
}

.review-padding {
  padding-left: 70px;
}

.padding-fix {
  margin-top: 10px;
  padding-top: 0px;
}

@media screen and (max-width: 426px) {
  .review-padding {
    padding-left: 50px !important;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .m-prof-sub ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .m-prof-sub {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
  }

  .mob {
    @media screen and (max-width: 900px) {
      position: relative;
      top: 140px;
      left: 301px;
      z-index: 10;
    }
  }

  .option-mob {
    @media screen and (max-width: 900px) {
      width: max-content;
    }
  }

  .m-prof {
    box-shadow: none !important;
    background: none !important;
  }

  .m-prof .circle-card-content {
    margin-top: 0rem !important;
  }
}

.info-phy {
  p {
    margin-bottom: 0px;
  }

  .prof-details-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }

  .prof-details-value {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #0f1734;
  }
}

.about-phy {
  margin-top: 60px;
  margin-left: 420px;
  margin-right: 10px;

  @media screen and (max-width: 700px) {
    margin-top: 0px;
  }
}

.prof-details-title {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.profile-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  margin-left: 17px;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.review-btns {
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  border: none;
  justify-content: center;
  width: 100%;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  // color: #0F1734;
}

.circle-btn {
  padding: 12px 24px;
  width: 335px;
  height: 48px;
  border-radius: 6px;
  border: none;
}

.phy-profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 937px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: -220px;
}

.banner {
  // min-height: 250px;
  // max-height: 400px;
  height: 400px;

  img {
    min-height: 250px;
    max-height: 400px;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.card-item {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 0 !important;
  line-height: 32px;
  color: #1e2945;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  align-self: center;
  border-radius: 50%;
}

.tag-icon-oran {
  // height: 17.5px;
  // width: 20px;
  color: #f5a623;
  font-size: 12px;
}

.physician-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  background: #fff0d6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color: #f5a623;
  text-transform: capitalize;
}

.tags {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  margin-right: 5px;
  border-radius: 4px;
  text-transform: capitalize;
}

.tag-cont {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 17.5px;
  margin-top: 16px;
}

.doc-info {
  .doc-name {
    font-weight: 700;
    font-size: 36px;
    // line-height: 46px;
    margin-bottom: 16px !important;
    color: #0f1734;
    white-space: inherit;
  }

  .loc {
    margin-bottom: 13px !important;
  }

  .doc-loc text-truncate,
  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.shadow-card {
  .p {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    color: #1e2945;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  margin-left: 365px;
  text-align: right;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: #0f1734;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}

.rating-box {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  padding: 5px 8px;
  display: flex;
  align-items: center;
  color: #fff;
  border-radius: 15px;

  .star-rating {
    margin-right: 5px;
  }

  span {
    color: #fff;
  }
}

@media screen and (max-width: 581px) {
  .doc-info {
    text-align: left;
    // margin-top: 10px;
  }

  .about-phy {
    margin-left: 10px;
  }

  .rating-box {
    position: absolute;
    left: 50%;
    bottom: -16px;
    transform: translateX(-50%);
    padding: 5px 8px;
    display: flex;
    align-items: center;
    color: #fff;
    border-radius: 15px;

    .star-rating {
      margin-right: 5px;
    }

    span {
      color: #fff;
    }
  }
}

//////////// old ui
.banner {
  // min-height: 300px;
  // max-height: 400px;
  height: 400px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.profile-image {
  min-width: 150px;
  height: 150px;

  border-radius: 50%;
  // margin-top: -45px;
}

.doc-info {
  .doc-name {
    font-size: 24px;
    font-weight: bolder;
    margin-bottom: 16px !important;
  }

  .doc-loc text-truncate,
  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  text-align: right;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}

.rating-box {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  padding: 5px 8px;
  display: flex;
  align-items: center;
  color: #fff;
  border-radius: 15px;

  .star-rating {
    margin-right: 5px;
  }

  span {
    color: #fff;
  }
}

@media screen and (max-width: 581px) {
  .banner {
    // min-height: 300px;
    // max-height: 400px;

    img {
      // height: 100%;
      height: 187px;
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/view/ViewHospitalProfile.vue